import React from "react";
import { PaginatedTable } from "ee-react-components";
import { process } from "../Process";
export var CommandHistoryTable = function (_a) {
    var chargerId = _a.chargerId;
    var resourceUrl = "".concat(process.env.NOC_SVC_URL, "/commands/charger/").concat(chargerId);
    var rowsFromResponse = function (response) { return response.commands; };
    var rowCountFromResponse = function (response) { return response.pages; };
    var columns = [
        {
            header: "ID",
            accessorFn: function (row) { return row.commandId; },
        },
        {
            header: "Command",
            accessorFn: function (row) {
                // Format command content for display
                if (row.commandContent.length === 1) {
                    var cmd = row.commandContent[0];
                    if (cmd.legacyCommand) {
                        return cmd.legacyCommand.command;
                    }
                    if (cmd.eventBusCommand) {
                        return "EventBus: ".concat(cmd.eventBusCommand.topic);
                    }
                    if (cmd.sendOcppMessage) {
                        return "OCPP Message";
                    }
                }
                return "".concat(row.commandContent.length, " command(s)");
            },
        },
        {
            header: "Status",
            accessorFn: function (row) { return row.latestStatus; },
        },
        {
            header: "Username",
            accessorFn: function (row) { return row.username; },
        },
        {
            header: "Created",
            accessorFn: function (row) {
                return new Date(row.createdDate).toLocaleString();
            },
        },
    ];
    return (React.createElement(PaginatedTable, { baseUrl: resourceUrl, itemsPerPage: 10, rowsFromResponse: rowsFromResponse, rowCountFromResponse: rowCountFromResponse, columnDefinitions: columns }));
};
